import RequestResourceView from './RequestResource.view';
export default RequestResourceView;
